// Frontend-only access gate.
// IMPORTANT: a fully frontend app cannot keep secrets truly hidden — any client-side
// JS can be read. We minimise exposure by storing only a SHA-256 digest of
// `${SALT}::${username}::${password}` in source. Plaintext credentials are NEVER
// shipped to the browser.
//
// The hash below corresponds to the official tutorial site credentials issued by
// BRAC Bank — refer to internal onboarding doc. Do not commit the plaintext to
// this repository.

const SALT = "cms-docs-v1";
const EXPECTED_HASH =
  "236a9f12901405a6b3f305e3a387681da7942702bb9b2dd39e02d87c16072f96";

const AUTH_KEY = "cms_session_v1";

const hex = (buf) =>
  Array.from(new Uint8Array(buf))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

export const sha256 = async (text) => {
  const enc = new TextEncoder().encode(text);
  const buf = await crypto.subtle.digest("SHA-256", enc);
  return hex(buf);
};

export const verifyCredentials = async (username, password) => {
  const candidate = `${SALT}::${username}::${password}`;
  const digest = await sha256(candidate);
  // Constant-time-ish compare
  if (digest.length !== EXPECTED_HASH.length) return false;
  let mismatch = 0;
  for (let i = 0; i < digest.length; i++) {
    mismatch |= digest.charCodeAt(i) ^ EXPECTED_HASH.charCodeAt(i);
  }
  return mismatch === 0;
};

export const setSession = async () => {
  // Store only an opaque session token, never the credentials.
  const token = await sha256(`${SALT}::session::${Date.now()}::${Math.random()}`);
  localStorage.setItem(AUTH_KEY, token);
};

export const clearSession = () => localStorage.removeItem(AUTH_KEY);

export const hasSession = () => !!localStorage.getItem(AUTH_KEY);
